import { AnimatedSprite, Texture, } from "pixi.js"

import debris0 from './debris/debris00.png'
import debris1 from './debris/debris01.png'
import debris2 from './debris/debris02.png'
import debris3 from './debris/debris03.png'
import debris4 from './debris/debris04.png'
import debris5 from './debris/debris05.png'
import debris6 from './debris/debris06.png'
import debris7 from './debris/debris07.png'
import debris8 from './debris/debris08.png'
import debris9 from './debris/debris09.png'
import debris10 from './debris/debris10.png'

import debris11 from './debris/debris11.png'
import debris12 from './debris/debris12.png'
import debris13 from './debris/debris13.png'
import debris14 from './debris/debris14.png'
import debris15 from './debris/debris15.png'
import debris16 from './debris/debris16.png'
import debris17 from './debris/debris17.png'
import debris18 from './debris/debris18.png'
import debris19 from './debris/debris19.png'
import debris20 from './debris/debris20.png'

import debris21 from './debris/debris21.png'
import debris22 from './debris/debris22.png'

export let debris: any


const debriss0 = Texture.from(debris0)
const debriss1 = Texture.from(debris1)
const debriss2 = Texture.from(debris2)
const debriss3 = Texture.from(debris3)
const debriss4 = Texture.from(debris4)
const debriss5 = Texture.from(debris5)
const debriss6 = Texture.from(debris6)
const debriss7 = Texture.from(debris7)
const debriss8 = Texture.from(debris8)
const debriss9 = Texture.from(debris9)
const debriss10 = Texture.from(debris10)

const debriss11 = Texture.from(debris11)
const debriss12 = Texture.from(debris12)
const debriss13 = Texture.from(debris13)
const debriss14 = Texture.from(debris14)
const debriss15 = Texture.from(debris15)
const debriss16 = Texture.from(debris16)
const debriss17 = Texture.from(debris17)
const debriss18 = Texture.from(debris18)
const debriss19 = Texture.from(debris19)
const debriss20 = Texture.from(debris20)

const debriss21 = Texture.from(debris21)
const debriss22 = Texture.from(debris22)

const textures = [
    debriss0,
    debriss1,
    debriss2,
    debriss3,
    debriss4,
    debriss5,
    debriss6,
    debriss7,
    debriss8,
    debriss9,
    debriss10,
    debriss11,
    debriss12,
    debriss13,
    debriss14,
    debriss15,
    debriss16,
    debriss17,
    debriss18,
    debriss19,
    debriss20,
    debriss21,
    debriss22,

]

debris = new AnimatedSprite(textures)
debris.animationSpeed = .5
debris.anchor.set(0.8, .2)
debris.scale.set(0.25)
debris.loop = false

